import {
    IDataArray
} from "./../index"

export class SurveyStatus implements IDataArray {
    public Pkid: number;
    public UserCount: number;
    public ActionType: string

    public GetById(): number {
        return this.Pkid;
    }
}